module.exports = __webpack_public_path__ + "img/c7.5a327787.png";